<template>
  <modal
    width="60%"
    :title="$t(title)"
    :visible.sync="isShowDialog"
    :top="'8vh'"
  >
    <div class="dialogClass" v-if="tabsArray.length">
      <div class="tabs">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in tabsArray"
            :key="item.type"
            :label="$t(item.label)"
            :name="item.type"
          >
            <template v-if="index !== 2">
              <span slot="label">
                <i
                  class="el-icon-warning"
                  :class="active === index ? 'active' : ''"
                  v-show="active === index && configStatusMap[active] === 1"
                ></i>
                {{ $t(item.label) }}
              </span>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 内容展示 keep-alive先放这里-->
      <div class="tab-content-scroll">
        <keep-alive>
          <component
            ref="componentContent"
            v-bind="$attrs"
            :is="componentContent"
            @onConfigStatusChange="onConfigStatusChange"
          ></component>
        </keep-alive>
      </div>
    </div>
  </modal>
</template>

<script>
import { getTabs } from '@/pages/equipment/sensor/components/sensor/cionfig/tabsController'

export default {
  name: 'ConfigDialog',
  components: {
    rule: () => import('./cionfig/Rule.vue'),
    net: () => import('./cionfig/Net.vue'),
    config: () => import('./cionfig/ConfigLog.vue'),
    SoundLightAlarm: () =>
      import(
        '@/pages/equipment/sensor/components/sensor/cionfig/4GTempTab/SoundLightAlarm.vue'
      ),
    GPSLocate: () =>
      import(
        '@/pages/equipment/sensor/components/sensor/cionfig/4GTempTab/GPSLocate.vue'
      )
  },
  props: ['isShowConfig'],
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShowConfig
      },
      set: function (val) {
        this.$emit('update:isShowConfig', val) // 可以优化成model  或者minx
      }
    }
  },
  data () {
    return {
      title: 'public.config_info',
      activeName: 'rule',
      active: 0,
      // 展示的tabs 根据sensorType的不同会改变
      tabsArray: [],
      componentContent: null,
      configStatusMap: {}
    }
  },
  mounted () {
    const type = this.$attrs.rowData.type

    this.tabsArray = getTabs(type)
    if (this.tabsArray.length) {
      this.componentContent = this.tabsArray[0].type
    }
  },
  methods: {
    handleClick ({ name, index }) {
      this.active = parseInt(index)
      this.componentContent = name
    },
    onConfigStatusChange (status) {
      if (!status) {
        return this.$set(this.configStatusMap, this.active, 2)
      }
      this.$set(this.configStatusMap, this.active, status)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/sensor.scss';

.dialogClass {
  max-height: 75vh;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

.tab-content-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}

.active {
  color: red;
  margin-right: 5px;
}
</style>
